import { Component, OnInit } from '@angular/core';
import { SessionService } from 'src/app/core/services/session.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { MenuService } from 'src/app/core/services/menu.service';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { SafeUrl } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';


const permissions = {
  USER_LIST: 1,
  USER_ADD: 2,
  USER_EDIT: 3,
  USER_DELETE: 4,
};

@Component({
  selector: 'app-side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.scss'],
})
export class SideNavigationComponent implements OnInit {
  profileName: string;
  jobTitle: string;
  showSubmenu: boolean = false;
  storageObject;
  profileImagePath: SafeUrl = '../assets/images/profile-avatar.svg';
  navMenuitems = [
    {
      // #0
      label: 'Dashboard',
      code: 'C_DASH',
      icon: 'assets/images/menu/menu_dashboard.svg',
      url: '/baseapp/dashboard',
      drop: false,
      isMenuActive: true,
      isSubMenuActive: false,
    },
    {
      // #1
      label: 'Integration',
      code: 'C_INTBRD',
      icon: 'assets/images/menu/menu_integration.svg',
      url: '/baseapp/integration',
      drop: false,
      isMenuActive: false,
      isSubMenuActive: false,
    },
    {
      // #2
      label: 'Monitor',
      code: 'C_MON',
      icon: 'assets/images/menu/menu_monitor.svg',
      url: '/baseapp/monitor',
      drop: false,
      isMenuActive: false,
      isSubMenuActive: false,
    },
    {
      // #3
      label: 'Alerts',
      code: 'C_ALERTS',
      icon: 'assets/images/menu/menu_alerts.svg',
      url: '/baseapp/alerts',
      drop: false,
      isMenuActive: false,
      isSubMenuActive: false,
    },
    {
      // #4
      label: 'Instances',
      code: 'C_INSTANCES',
      icon: 'assets/images/menu/menu_integration.svg',
      url: '/baseapp/instances',
      drop: false,
      isMenuActive: false,
      isSubMenuActive: false,
    },
    {
      // #5
      label: 'Marketplace',
      code: 'C_MARKET',
      icon: 'assets/images/menu/menu_catalogue.svg',
      url: '/baseapp/marketplace',
      drop: false,
      isMenuActive: false,
      isSubMenuActive: false,
    },
    {
      // #6
      label: 'Catalog Admin',
      code: 'C_CAT_ADMIN',
      icon: 'assets/images/menu/catalog-admin.svg',
      url: '/baseapp/user',
      drop: true,
      isMenuActive: false,
      isSubMenuActive: false,
      class: 'sub',
      submenu: [
        {
          label: 'Category',
          code: 'CAT',
          url: '/baseapp/category',
          isActive: false,
        },
        {
          label: 'Brand',
          code: 'BRAND',
          url: '/baseapp/brand',
          isActive: false,
        },
        {
          label: 'Product',
          code: 'PRODUCT',
          url: '/baseapp/product',
          isActive: false,
        },
      ],
    },
    {
      // #7
      label: 'API Catalog',
      code: 'C_API_CAT',
      icon: 'assets/images/menu/menu_catalogue.svg',
      url: '/baseapp/api-catalog',
      drop: false,
      isMenuActive: false,
      isSubMenuActive: false,
    },
    {
      // #8
      label: 'Management',
      code: 'C_MANAGMNT',
      icon: 'assets/images/menu/menu_management.svg',
      url: '/baseapp/user',
      drop: true,
      isMenuActive: false,
      isSubMenuActive: false,
      class: 'sub',
      submenu: [
        { label: 'User', code: 'USR', url: '/baseapp/user', isActive: false },
        {
          label: 'User Group',
          code: 'USR_GRP',
          url: '/baseapp/user-group',
          isActive: false,
        },
        {
          label: 'Organization',
          code: 'ORG_ADMIN',
          url: '/baseapp/organization',
          isActive: false,
        },
        {
          label: 'Catalog Manager',
          code: 'CAT_MANAGER',
          url: '/baseapp/catalog-manager',
          isActive: false,
        },
        {
          label: 'Product Updates',
          code: 'PRODUCT_UPDATE',
          url: '/baseapp/product-updates',
          isActive: false,
        },
      ],
    },
    {
      // #9
      label: 'Database Environment',
      code: 'C_DATABASE_ENV',
      icon: 'assets/images/menu/menu_integration.svg',
      url: '/baseapp/database-env',
      drop: false,
      isMenuActive: false,
      isSubMenuActive: false,
    },
    {
      // #10
      label: 'Datalake Environment',
      code: 'C_DATALAKE_ENV',
      icon: 'assets/images/menu/menu_integration.svg',
      url: '/baseapp/datalake-env',
      drop: false,
      isMenuActive: false,
      isSubMenuActive: false,
    },
    {
      // #11
      label: 'ML Environmet',
      icon: 'assets/images/menu/menu_integration.svg',
      url: '/baseapp/ml-environment',
      drop: false,
      isMenuActive: false,
      isSubMenuActive: false,
    },
    {
      // #12
      label: 'Vendor',
      // code: 'C_VENDOR',
      icon: 'assets/images/menu/menu_integration.svg',
      url: '/baseapp/vendor-list',
      drop: false,
      isMenuActive: false,
      isSubMenuActive: false,
    },
    {
      // #13
      label: 'Bizintel360 Visualization',
      code: 'C_ACCESS_VISUALIZATION',
      icon: 'assets/images/menu/menu_integration.svg',
      url: '/analytics/',
      drop: false,
      isMenuActive: false,
      isSubMenuActive: false,
    },
    {
      // #14
      label: 'Goldfinch',
      code: 'C_GOLD',
      icon: 'assets/images/menu/Bird.svg',
      url: '/baseapp/user',
      drop: true,
      isMenuActive: false,
      isSubMenuActive: false,
      class: 'sub',
      submenu: [
        {
          label: 'Goldfinch AI Agent',
          code: 'GOLDFINCH',
          url: '/baseapp/gold-finch-chat',
          isActive: true,
        },
        // { label: 'Data Source', url: '', isActive: true }
      ],
    },
    { // #15
      label: 'Data Source Management',
      code: 'C_DATA_INDEX',
      icon: 'assets/images/menu/menu_catalogue.svg',
      url: '/baseapp/data-source-management',
      drop: false,
      isMenuActive: false,
      isSubMenuActive: false,
    },
  ];
  bizdataLogo = 'assets/images/bizdata-welcome-logo.svg';
  roleId;

  constructor(
    public sessionService: SessionService,
    private menuService: MenuService,
    private backendService: BackendService,
    private router: Router,
    public helperService: HelperService,
    private http:HttpClient
  ) { }

  ngOnInit() {
    this.helperService.objectFromStorage$.subscribe((obj) => {
      this.storageObject = obj;
      if(this.storageObject.profileImageId){
        this.getProfileImage(obj);
      }
    });
     this.menuService.tokenFromStorage$.subscribe(async (res) => {
      if (res) {
        let token: string = res as any;
        // let decoded_token = JSON.parse(atob(token.split('.')[1]));
        let decoded_token;
        await this.helperService.decode(token).then((res)=>{
          decoded_token=res;
        })
        this.roleId = decoded_token.role.role_id;
        // //console.log(decoded_token);
        let gold_obj = this.findTheObject(this.navMenuitems, "C_GOLD");
        let visual_obj = this.findTheObject(this.navMenuitems, "C_ACCESS_VISUALIZATION");
        let index_obj = this.findTheObject(this.navMenuitems, "C_DATA_INDEX");
        let management_obj = this.findTheObject(this.navMenuitems, "C_MANAGMNT");

        // SUPER ADMIN MENU
        if (decoded_token.role.role_id == 1) {
          for (let i = 0; i < this.navMenuitems.length; i++) {
            this.navMenuitems[i].isMenuActive = false;
            if (i == 13) continue;
            this.navMenuitems[i].isMenuActive = true;
            if (i == 6 || i == 8) {
              if (this.navMenuitems[i].submenu.length > 0) {
                for (let j = 0; j < this.navMenuitems[i].submenu.length; j++) {
                  this.navMenuitems[i].submenu[j].isActive = true;
                  // this.navMenuitems[i].submenu[j].isActive = false;
                  // if (j == 1) continue;
                  // this.navMenuitems[i].submenu[j].isActive = true;
                }
              }
            }
          }
          let gold_acc=false;
          let va_acc=false;
          this.helperService.getGoldfinchAcces().subscribe(toggle => {
            gold_acc=toggle ? true : false;
            for (let i = 0; i < this.navMenuitems.length; i++) {
              if (this.navMenuitems[i].code == 'C_GOLD')
                this.navMenuitems[i].isMenuActive = toggle ? true : false;
              this.navMenuitems[i].isSubMenuActive = false;
              if (this.navMenuitems[i].code == 'C_DATA_INDEX'){
                if(va_acc){
                  this.navMenuitems[i].isMenuActive = true;
                }else{
                  this.navMenuitems[i].isMenuActive = toggle ? true : false;
                }
              }


              // if (management_obj) {
              //   let user_group_obj = this.findTheObject(management_obj.submenu, "USR_GRP");
              //   if (user_group_obj){
              //     if(va_acc){
              //       user_group_obj.isActive = true;
              //     }else{
              //       user_group_obj.isActive = toggle ? true : false;
              //     }
              //   }
              // } else {
              //   management_obj.isMenuActive = false;
              // }
              // if (management_obj) {
              //   let user_group_obj = this.findTheObject(management_obj.submenu, "USR_GRP");
              //   if (user_group_obj){
              //     if(va_acc){
              //       user_group_obj.isActive = true;
              //     }else{
              //       user_group_obj.isActive = toggle ? true : false;
              //     }
              //   }
              // } else {
              //   management_obj.isMenuActive = false;
              // }
            }
          })
          this.helperService.getVisualizationAcces().subscribe(toggle => {
            va_acc=toggle?true:false;
            for (let i = 0; i < this.navMenuitems.length; i++) {
              if (this.navMenuitems[i].code == 'C_ACCESS_VISUALIZATION')
                this.navMenuitems[i].isMenuActive = toggle ? true : false;

              if (this.navMenuitems[i].code == 'C_DATA_INDEX'){
                if(gold_acc){
                  this.navMenuitems[i].isMenuActive = true;
                }else{
                  this.navMenuitems[i].isMenuActive = toggle ? true : false;
                }
              }


              if (management_obj) {
                let user_group_obj = this.findTheObject(management_obj.submenu, "USR_GRP");
                if (user_group_obj){
                  if(toggle){
                    user_group_obj.isActive = true;
                  }else{
                    user_group_obj.isActive = toggle ? true : false;
                  }
                }
              } else {
                management_obj.isMenuActive = false;
              }
            }
          })

          decoded_token.permissions.forEach(perm => {
            if (perm.perm_mod == 'ACCESS_GOLDFINCH'){
              this.http.get('assets/feature_switching.json').subscribe((res: any) => {
                gold_obj.isMenuActive = res.isGoldfinchEnableFromENV;
                index_obj.isMenuActive = res.isGoldfinchEnableFromENV;
              });
              // if (management_obj) {
              //   let user_group_obj = this.findTheObject(management_obj.submenu, "USR_GRP");
              //   if (user_group_obj)
              //     user_group_obj.isActive = environment.isGoldfinchEnableFromENV;
              //   else
              //     user_group_obj.isActive = false;
              // }
            }

            if (perm.perm_mod == 'ACCESS_VISUALIZATION') {
              this.http.get('assets/feature_switching.json').subscribe((res: any) => {
                visual_obj.isMenuActive = res.isVisualizationAccessEnableFromENV;
                index_obj.isMenuActive = res.isVisualizationAccessEnableFromENV;
              });

              if (management_obj) {
                let user_group_obj = this.findTheObject(management_obj.submenu, "USR_GRP");
                if (user_group_obj){
                  this.http.get('assets/feature_switching.json').subscribe((res: any) => {
                    user_group_obj.isActive = res.isVisualizationAccessEnableFromENV;
                  });
              }
            }
            }
          })
        }

        // ORGANIZATION ADMIN MENU
        if (decoded_token.role.role_id == 2) {
          for (let i = 0; i < this.navMenuitems.length; i++) {
            this.navMenuitems[i].isMenuActive = false;
            if (i == 2 || i == 3 || i == 4 || i == 5 || i == 6 || i == 7 || i == 9 || i == 10 || i == 11 || i==12)
              continue;
            this.navMenuitems[i].isMenuActive = true;
            let gold_acc=false;
            let va_acc=false;
            this.helperService.getGoldfinchAcces().subscribe(toggle => {
              gold_acc=toggle ? true : false;
              for (let i = 0; i < this.navMenuitems.length; i++) {
                if (this.navMenuitems[i].code == 'C_GOLD')
                  this.navMenuitems[i].isMenuActive = toggle ? true : false;
                this.navMenuitems[i].isSubMenuActive = false;
                if (this.navMenuitems[i].code == 'C_DATA_INDEX'){
                  if(va_acc){
                    this.navMenuitems[i].isMenuActive = true;
                  }else{
                    this.navMenuitems[i].isMenuActive = toggle ? true : false;
                  }
                }


                // if (management_obj) {
                //   let user_group_obj = this.findTheObject(management_obj.submenu, "USR_GRP");
                //   if (user_group_obj){
                //     if(va_acc){
                //       user_group_obj.isActive = true;
                //     }else{
                //       user_group_obj.isActive = toggle ? true : false;
                //     }
                //   }
                // } else {
                //   management_obj.isMenuActive = false;
                // }
              }
            })
            this.helperService.getVisualizationAcces().subscribe(toggle => {
              va_acc=toggle ? true : false;
              for (let i = 0; i < this.navMenuitems.length; i++) {
                if (this.navMenuitems[i].code == 'C_ACCESS_VISUALIZATION')
                  this.navMenuitems[i].isMenuActive = toggle ? true : false;

                if (this.navMenuitems[i].code == 'C_DATA_INDEX'){
                  if(gold_acc){
                    this.navMenuitems[i].isMenuActive = true;
                  }else{
                    this.navMenuitems[i].isMenuActive = toggle ? true : false;
                  }
                }


                if (management_obj) {
                  let user_group_obj = this.findTheObject(management_obj.submenu, "USR_GRP");
                  if (user_group_obj){
                    if(toggle){
                      user_group_obj.isActive = true;
                    }else{
                      user_group_obj.isActive = toggle ? true : false;
                    }
                  }
                } else {
                  management_obj.isMenuActive = false;
                }
              }
            })


            decoded_token.permissions.forEach(perm => {
              if (perm.perm_mod == 'ACCESS_GOLDFINCH'){
                this.http.get('assets/feature_switching.json').subscribe((res: any) => {
                  gold_obj.isMenuActive = res.isGoldfinchEnableFromENV;
                  index_obj.isMenuActive = res.isGoldfinchEnableFromENV;
                });
                // if (management_obj) {
                //   let user_group_obj = this.findTheObject(management_obj.submenu, "USR_GRP");
                //   if (user_group_obj)
                //     user_group_obj.isActive = environment.isGoldfinchEnableFromENV;
                //   else
                //     user_group_obj.isActive = false;
                // }
              }
              if (perm.perm_mod == 'ACCESS_VISUALIZATION') {
                this.http.get('assets/feature_switching.json').subscribe((res: any) => {
                  visual_obj.isMenuActive = res.isVisualizationAccessEnableFromENV;
                  index_obj.isMenuActive = res.isVisualizationAccessEnableFromENV;
                });
                if (management_obj) {
                  let user_group_obj = this.findTheObject(management_obj.submenu, "USR_GRP");
                  if (user_group_obj){
                    this.http.get('assets/feature_switching.json').subscribe((res: any) => {
                      user_group_obj.isActive = res.isVisualizationAccessEnableFromENV;
                    });
                  }else{
                    user_group_obj.isActive = false;
                  }
              }
            }
          });

            if (i == 6 || i == 8) {
              if (this.navMenuitems[i].submenu.length > 0) {
                for (let j = 0; j < this.navMenuitems[i].submenu.length; j++) {
                  this.navMenuitems[i].submenu[j].isActive = false;
                  if (j == 2 || j == 3 || j == 4) continue;
                  this.navMenuitems[i].submenu[j].isActive = true;
                }
              }
            }
          }
        }

        // CATALOG ADMIN MENU
        if (decoded_token.role.role_id == 4) {
          for (let i = 0; i < this.navMenuitems.length; i++) {
            this.navMenuitems[i].isMenuActive = false;
            if (i == 6 || i == 8) {
              if (this.navMenuitems[i].submenu.length > 0) {
                for (let j = 0; j < this.navMenuitems[i].submenu.length; j++) {
                  this.navMenuitems[i].submenu[j].isActive = true;
                }
              }
            }
          }
          this.navMenuitems[0].isMenuActive = true;
          this.navMenuitems[6].isMenuActive = true;
          this.navMenuitems[7].isMenuActive = true;
        }

        // STUDENT MENU
        if (decoded_token.role.role_id == 5) {
          for (let i = 0; i < this.navMenuitems.length; i++) {
            this.navMenuitems[i].isMenuActive = false;
            if (i == 6 || i == 8) {
              if (this.navMenuitems[i].submenu.length > 0) {
                for (let j = 0; j < this.navMenuitems[i].submenu.length; j++) {
                  this.navMenuitems[i].submenu[j].isActive = false;
                }
              }
            }
          }
          this.navMenuitems[0].isMenuActive = true;
        }

        // USER MENU
        if (decoded_token.role.role_id == 3) {
          for (let i = 0; i < this.navMenuitems.length; i++) {
            this.navMenuitems[i].isMenuActive = false;
            if (i == 6 || i == 8) {
              if (this.navMenuitems[i].submenu.length > 0) {
                for (let j = 0; j < this.navMenuitems[i].submenu.length; j++) {
                  this.navMenuitems[i].submenu[j].isActive = false;
                }
              }
            }
          }
          this.navMenuitems[0].isMenuActive = true;
          // this.navMenuitems[1].isMenuActive = true;
          decoded_token.permissions.forEach((perm) => {
            if (perm.perm_mod == 'USER_LIST') {
              let obj = this.findTheObject(this.navMenuitems, 'C_MANAGMNT');
              obj.isMenuActive = true;
              obj.submenu[0].isActive = true;
            } else if (perm.perm_mod == 'IB_LIST') {
              let obj = this.findTheObject(this.navMenuitems, 'C_INTBRD');
              obj.isMenuActive = true;
            } else if (perm.perm_mod == 'API_CAT_LIST') {
              let obj = this.findTheObject(this.navMenuitems, 'C_API_CAT');
              obj.isMenuActive = true;
              // } else if (perm.perm_mod == 'ACCESS_VISUALIZATION') {
              //   let obj = this.findTheObject(this.navMenuitems, "C_ACCESS_VISUALIZATION");
              //   obj.isMenuActive = true;
            } else if (perm.perm_mod == "ACCESS_GOLDFINCH") {
              //console.log("perm.perm_mod" + perm.perm_mod)
              let goldfinchObj = this.findTheObject(this.navMenuitems, "C_GOLD");
              let dataSourceObj = this.findTheObject(this.navMenuitems, "C_DATA_INDEX");
              this.http.get('assets/feature_switching.json').subscribe((res: any) => {
                dataSourceObj.isMenuActive = res.isGoldfinchEnableFromENV;
                // goldfinchObj.isMenuActive = true;
                goldfinchObj.isMenuActive = res.isGoldfinchEnableFromENV;
              });
            } else if (perm.perm_mod == 'ACCESS_VISUALIZATION') {
              let dataSourceObj = this.findTheObject(this.navMenuitems, "C_DATA_INDEX");
              let obj = this.findTheObject(this.navMenuitems, 'C_ACCESS_VISUALIZATION');
              this.http.get('assets/feature_switching.json').subscribe((res: any) => {
                dataSourceObj.isMenuActive = res.isVisualizationAccessEnableFromENV;
                obj.isMenuActive = res.isVisualizationAccessEnableFromENV;
              });

              const managementMenuItem = this.navMenuitems.find(
                (item) => item.label === 'Management'
              );
              if (managementMenuItem) {
                const userGroupSubmenuItem = managementMenuItem.submenu.find(
                  (subitem) => subitem.label === 'User Group'
                );
                if (userGroupSubmenuItem) {
                  // userGroupSubmenuItem.isActive = true;
                  this.http.get('assets/feature_switching.json').subscribe((res: any) => {
                    userGroupSubmenuItem.isActive = res.isUserGroupAccessEnableFromENV;
                  });
                  // userGroupSubmenuItem.isActive = environment.isVisualizationAccessEnableFromENV;
                }
              }

            }
            if (perm.perm_mod == "ACCESS_GOLDFINCH") {
              let dataSourceObj = this.findTheObject(this.navMenuitems, "C_DATA_INDEX");
              dataSourceObj.isMenuActive = false;
            } else if (perm.perm_mod == 'ACCESS_VISUALIZATION') {
              let dataSourceObj = this.findTheObject(this.navMenuitems, "C_DATA_INDEX");
              dataSourceObj.isMenuActive = true;
              //console.log(dataSourceObj);
            }
          });
        }


        // this.navMenuitems.forEach(perm => {
        //   if (perm.code == 'C_GOLD') {
        //     perm.isMenuActive = false;
        //     if (environment.isGoldfinchEnable) {
        //       perm.isMenuActive = true;
        //     }
        //   }
        // })
      }
    });
  }

  getProfileImage(_storage) {
    let payload = {
      img_collection_id: _storage.profileImageId,
    };
    this.backendService
      .fileUpload('getUserProfileImage', 'post', payload, _storage.token)
      .subscribe(
        (data: any) => {
          this.profileImagePath =
            'data:image/jpg;base64,' + data.profileImage_hash;
        },
        (error) => {
          //console.log(error);
        }
      );
  }

  findTheObject(array, key) {
    return array.find(function (o) {
      return o.code == key;
    });
  }

  menuItemHandler(): void {
    this.showSubmenu = !this.showSubmenu;
  }

  toggleDropdown(label) {
    const obj = this.navMenuitems.find(function (o) {
      return o.label === label;
    });
    obj['isSubMenuActive'] = !obj.isSubMenuActive;
  }

  route(item) {
    if(item.url == ''){
      return;
    }
    if (item.code == 'C_ACCESS_VISUALIZATION') {
      let link = environment.app_base_url;
      // //console.log(this.storageObject);
      window.open(
        link + '/analytics/#/ezlogin/' + this.storageObject.token,
        '_blank'
      );
    } else {
      let link = item.url;
      this.router.navigate([link]);
    }
  }
}
